import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Globe } from "lucide-react";
import { HasMark } from "@/components/BrandText";
import { COMPANY, NAV_LINKS, SERVICES } from "@/data/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative mt-24 bg-[#070707] border-t border-[#D4AF37]/15">
      <div className="absolute top-0 left-0 right-0 gold-divider opacity-70" />
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="flex items-center gap-3">
            <img src={COMPANY.logo} alt="HAS UMC" className="h-20 w-20 object-contain rounded-sm bg-black ring-1 ring-[#D4AF37]/30" />
            <div className="leading-tight">
              <div className="font-display text-[34px] text-white">HAS</div>
              <div className="text-[11px] uppercase tracking-[0.22em] text-[#D4AF37]/80">Universal Management Consultancy</div>
            </div>
          </div>
          <p className="mt-5 text-sm leading-relaxed text-white/60 max-w-sm">
            Helping Businesses Grow Through Strategy, Research & Market Access.
          </p>
          <p className="mt-4 text-[11px] uppercase tracking-[0.22em] text-[#D4AF37]">{COMPANY.tagline}</p>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-display text-sm text-white mb-5 tracking-wide">Navigate</h4>
          <ul className="space-y-2">
            {NAV_LINKS.map(l => (
              <li key={l.to}>
                <Link to={l.to} data-testid={`footer-link-${l.label.toLowerCase()}`} className="text-sm text-white/60 hover:text-[#D4AF37] transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-display text-sm text-white mb-5 tracking-wide">Practices</h4>
          <ul className="space-y-2">
            {SERVICES.slice(0,5).map(s => (
              <li key={s.id}>
                <Link to={`/services#${s.id}`} className="text-sm text-white/60 hover:text-[#D4AF37] transition-colors">
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="font-display text-sm text-white mb-5 tracking-wide">Contact</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex gap-2"><MapPin size={14} className="mt-1 text-[#D4AF37]" /><span>{COMPANY.location}</span></li>
            <li className="flex gap-2"><Phone size={14} className="mt-1 text-[#D4AF37]" /><a href={`tel:${COMPANY.phone.replace(/\s/g,"")}`} className="hover:text-[#D4AF37]">{COMPANY.phone}</a></li>
            <li className="flex gap-2"><Mail size={14} className="mt-1 text-[#D4AF37]" /><a href={`mailto:${COMPANY.email}`} className="hover:text-[#D4AF37]">{COMPANY.email}</a></li>
            <li className="flex gap-2"><Globe size={14} className="mt-1 text-[#D4AF37]" /><span>{COMPANY.website}</span></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <div>© {new Date().getFullYear()} <HasMark /> Universal Management Consultancy LLC. All rights reserved.</div>
          <div className="tracking-[0.22em] uppercase">Dubai · UAE · India · International</div>
        </div>
      </div>
    </footer>
  );
}
